// extracted by mini-css-extract-plugin
module.exports = {"Count":"FiltersPanel_Count__1-bVA","Label":"FiltersPanel_Label__1CX14"};